<div class="listing-details-wrapper">
  <ion-progress-bar [value]="completePercent / 100" class="divider-line" style="height: 3px"></ion-progress-bar>
  <div class="listing-icon icon-boondock _36-px">
    <div class="w-embed" style="width: 100%">
      <curbnturf-map-icons type="pricePinFilled" [primary]="true"> </curbnturf-map-icons>
    </div>
  </div>
  <img
    [src]="photoUrl"
    [alt]="photoCaption || 'Image for ' + getName()"
    loading="lazy"
    width="380"
    class="listing-info-image"
  />
  <div class="listing-info-description">
    <div class="listing-name-header">
      <h3 [innerHtml]="getName()"></h3>
      <span *ngIf="multiSite" class="multi-site-designator">(Multi-Site)</span>
      <ion-chip *ngIf="isAvailable" color="primary" outline="true">Published</ion-chip>
      <ion-chip *ngIf="!isAvailable && isComplete" color="tertiary" outline="true">Hidden</ion-chip>
    </div>
    <div class="listing-status">
      <div *ngIf="incompleteMessages.length > 0">
        <ion-button id="info-button-{{ listing.syncId }}" fill="clear" size="small">
          <ion-icon name="information-circle"></ion-icon>
        </ion-button>
        <ion-popover
          trigger="info-button-{{ listing.syncId }}"
          reference="event"
          dismiss-on-select="true"
          *ngIf="incompleteMessages.length > 0"
        >
          <ng-template>
            <ion-content>
              <ion-list>
                <ion-item *ngFor="let message of incompleteMessages" lines="full">{{ message }}</ion-item>
              </ion-list>
            </ion-content>
          </ng-template>
        </ion-popover>
      </div>

      <div>
        Your property is {{ completePercent }}% complete<span *ngIf="isComplete">!</span>
        <span *ngIf="!isComplete"> finish it now. </span>
      </div>
    </div>
    <div *ngIf="imagesIncomplete && listing.available && listingMissingImagePublishWindow" class="warning-notice">
      This property is missing images. You have
      <strong>{{ incompleteTimeRemaining }} day<span *ngIf="incompleteTimeRemaining !== 1">(s)</span></strong>
      remaining before the property is unpublished.
    </div>
    <div *ngIf="imagesIncomplete && !listingMissingImagePublishWindow && !listing.available" class="warning-notice">
      This property is missing images. You must add the required images before you can publish your site again.
    </div>
  </div>
  <div class="listing-options-inner">
    <a *ngIf="!isComplete" (click)="resumeWizard()" class="cnt-button w-button"> Resume </a>
    <a
      *ngIf="isComplete"
      [routerLink]="['', 'properties', 'edit', listing?.id ?? listing?.syncId]"
      class="cnt-button w-button"
    >
      Edit
    </a>
    <a [routerLink]="listingRoute" class="cnt-button w-button"> View </a>

    <ng-container *ngIf="publishable && isOnline">
      <ng-template #publishTemplate>
        <button type="button" class="cnt-button w-button">Publish</button>
      </ng-template>
      <curbnturf-hide-confirmation-modal
        [name]="'publish ' + listing?.name"
        [template]="publishTemplate"
        [hideFunction]="publish(listing)"
        *ngIf="!isAvailable"
      >
      </curbnturf-hide-confirmation-modal>
    </ng-container>

    <ng-container *ngIf="isAvailable && isOnline">
      <ng-template #hideTemplate>
        <button type="button" class="cnt-button w-button">Hide</button>
      </ng-template>
      <curbnturf-hide-confirmation-modal
        [name]="'hide ' + listing?.name"
        [template]="hideTemplate"
        [hideFunction]="hide(listing)"
        *ngIf="listing?.available"
      >
      </curbnturf-hide-confirmation-modal>
    </ng-container>

    <ng-template #listingDeleteTemplate>
      <button type="button" class="delete-button cnt-button">
        <span class="cnt-button-icon">
          <curbnturf-misc-svg icon="new-trash" class="normal"> </curbnturf-misc-svg>
          <curbnturf-misc-svg icon="new-trash" color="#fff" class="hovered"> </curbnturf-misc-svg>
        </span>
        <span class="cnt-button-copy">Delete</span>
      </button>
    </ng-template>
    <curbnturf-delete-confirmation-modal
      [name]="listing?.getName()"
      [template]="listingDeleteTemplate"
      [deleteFunction]="removeListingFunction(listing?.id ?? listing?.syncId)"
    >
    </curbnturf-delete-confirmation-modal>
  </div>
</div>
<div *ngIf="multiSite" class="listing-sites-wrapper">
  <table class="site-list">
    <tr>
      <th>Name</th>
      <th class="collapsable">Price</th>
      <th>Available</th>
      <th>Images</th>
      <th>&nbsp;</th>
    </tr>
    <ng-container *ngFor="let site of sites">
      <tr>
        <td colspan="5">
          <ion-progress-bar color="medium" [value]="siteCompletePercentage(site) / 100" class="divider-line" style="height: 3px"></ion-progress-bar>
        </td>
      </tr>
      <tr>
        <td class="site-name-column d-flex flex-gap d-flex-column">
          <ion-button size="small" (click)="onEditSiteName(site)" color="light"><ion-icon name="pencil"></ion-icon></ion-button>
          <ion-label class="no-wrap">{{ site.name }} <span class="collapsable">({{ siteCompletePercentage(site) }}%)</span></ion-label>
        </td>
        <td class="text-right collapsable">{{ site.price ?? 0 | currency }}</td>
        <td class="text-right">
          <ion-button color="secondary" size="small" (click)="onToggleSiteEnable(site)">
            <ion-icon *ngIf="site.available" name="checkmark-sharp"></ion-icon>
            <ion-icon *ngIf="!site.available" name="close-sharp"></ion-icon>
            <ion-label *ngIf="site.available" class="collapsable">Published</ion-label>
            <ion-label *ngIf="!site.available" class="collapsable">Hidden</ion-label>
          </ion-button>
        </td>
        <td class="text-right no-wrap">
          {{ site.photos ? site.photos.length : 0 }}
          <ion-button (click)="onUploadSitePhotos(site)"><ion-icon name="cloud-upload"></ion-icon></ion-button>
        </td>
        <td class="text-right" nowrap>
          <ion-button size="small" (click)="onEditSite(site)"><ion-label class="collapsable">Edit Site</ion-label><ion-icon name="arrow-forward"></ion-icon></ion-button>
        </td>
      </tr>
      <tr>
        <td class="fine-print" colspan="5">{{ site.description }}</td>
      </tr>
    </ng-container>
  </table>
</div>
